import { space, colors, Box } from '@workday/canvas-kit-react'
import React from 'react'
import AlertCard from './AlertCard'
import TimeDisplayOption from '../models/TimeDisplayOptions'
import { AlertModel } from '../../models/AlertModel'
import { AgencyModel } from '../../models/AgencyModel'

export interface AlertCardContainerProps {
  timeDisplayOption: TimeDisplayOption
  alert: AlertModel
  agency: AgencyModel
}

const AlertCardContainer = ({ timeDisplayOption, alert, agency }: AlertCardContainerProps) => {
  return (
    <Box padding={space.s} borderBottom={`1px solid ${colors.soap600}`}>
      <AlertCard alert={alert} agency={agency} timeDisplayOption={timeDisplayOption} />
    </Box>
  )
}

export default AlertCardContainer
